'use client';

import { BigNum, PRICE_PRECISION_EXP } from '@drift-labs/sdk';
import { UIMarket } from '@drift/common';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { getMarketPriceDecimals } from 'src/constants/marketDecimalConfig';
import { AccountOpenPosition } from 'src/@types/positions';

interface EntryPriceCellProps {
	position: AccountOpenPosition;
}

export function EntryPriceCell({ position }: EntryPriceCellProps) {
	const { entryPrice, marketIndex, isIsolatedBalanceOnly } = position;

	if (isIsolatedBalanceOnly) {
		return <span className="text-text-secondary">-</span>;
	}

	const uiMarket = UIMarket.createPerpMarket(marketIndex);
	const decimalPlaces = getMarketPriceDecimals(uiMarket.baseAssetSymbol());

	return (
		<NumberDisplay
			value={BigNum.from(entryPrice, PRICE_PRECISION_EXP)}
			decimals={decimalPlaces}
			type="currency"
		/>
	);
}
